import { buildEvent } from '../utils';

export const SWAP_EVENT = buildEvent('swap', 'SwapEvent');
